/**
 * Copy, destinations, and class names for the drawn public 404.
 *
 * Frames: dev.pen "Público A — 404 (rota *) — Desktop 1440" (jICeS3)
 * and "Público A — 404 (rota *) — Mobile 390" (oKkzHD).
 * NotFound404.view.tsx and NotFound404.css both read this module.
 * Neither file invents a second set of labels or class names.
 */

export const NOT_FOUND_DOCUMENT_TITLE =
  "Página não encontrada | Acertei Questões";

export const NOT_FOUND_EYEBROW = "ERRO 404";

export const NOT_FOUND_TITLE = "Página não encontrada";

export const NOT_FOUND_LEAD =
  "O endereço pode ter mudado ou ter sido digitado errado. Use um dos caminhos abaixo.";

/** Decorative digits inside the desktop stage. Not the page heading. */
export const NOT_FOUND_STAGE_DIGITS = "404";

export type NotFoundActionKind = "primary" | "secondary";

export type NotFoundAction = {
  label: string;
  to: string;
  kind: NotFoundActionKind;
};

/** Pill actions. Primary is first. Both exist at every width. */
export const NOT_FOUND_ACTIONS: readonly NotFoundAction[] = [
  { label: "Ir para o início", to: "/", kind: "primary" },
  { label: "Ver planos", to: "/planos", kind: "secondary" },
];

export type NotFoundTextLink = {
  label: string;
  to: string;
};

/** Underlined text actions under the pills. */
export const NOT_FOUND_TEXT_LINKS: readonly NotFoundTextLink[] = [
  { label: "Contato", to: "/contato" },
  { label: "Entrar", to: "/login" },
];

/**
 * Class names shared by the view and the stylesheet.
 * The view applies these and no others on the 404 markup.
 */
export const notFoundClass = {
  page: "public-404",
  hero: "public-404__hero",
  stage: "public-404__stage",
  teal: "public-404__teal",
  emerald: "public-404__emerald",
  amber: "public-404__amber",
  sky: "public-404__sky",
  digits: "public-404__digits",
  narrowEmerald: "public-404__narrow-emerald",
  narrowAmber: "public-404__narrow-amber",
  narrowTeal: "public-404__narrow-teal",
  copy: "public-404__copy",
  eyebrow: "public-404__eyebrow",
  title: "public-404__title",
  lead: "public-404__lead",
  actions: "public-404__actions",
  primary: "public-404__primary",
  secondary: "public-404__secondary",
  links: "public-404__links",
  textLink: "public-404__text-link",
} as const;
